import { BuilderComponentGroup } from '../types'

export const PageDashboard: BuilderComponentGroup = {
  id: 'page-dashboard',
  title: 'Page Dashboard',
  components: [
    {
      compId: 'page-dashboard1',
      title: 'Dashboard 1',
      icon: 'Dashboard1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
